import React, { ComponentType } from 'react';
import EnterpriseLayout from 'src/components/enterprise/layout/EnterpriseLayout';

interface WithEnterpriseLayoutProps {
  pageTitle: string;
  isEditing?: boolean;
  isEditingMealCredit?: boolean;
  useFluidContainer?: boolean;
}

export const withEnterpriseLayout = <P extends WithEnterpriseLayoutProps>(
  Component: ComponentType<P>
): React.FC<P> => {
  return function EnterpriseLayoutWrapper(props: P): JSX.Element {
    const { pageTitle, useFluidContainer, ...rest } = props;

    return (
      <EnterpriseLayout
        pageTitle={pageTitle}
        useFluidContainer={useFluidContainer}
      >
        <Component {...(rest as P)} />
      </EnterpriseLayout>
    );
  };
};

export default withEnterpriseLayout;
